// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Icon from 'Common/Icon';

import classNames from 'classnames';
import scrollToTopOfPage from 'Common/scrollToTopOfPage';
import updateQueryString from 'Common/updateQueryString';
import isWindow from 'Common/isWindow';
import isWindowProp from 'Common/isWindowProp';
import { gtmEventPush } from 'utils/gtm/events';

import styles from 'components/Pagination.scss';

/**
 * <Pagination /> component.
 */
class Pagination extends PureComponent<*, *> {
  /**
   * @param {object} props - props passed
   */
  constructor(props: Object) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   */
  static propTypes = {
    fetchUpdatedQuery: PropTypes.func,
    currentPage: PropTypes.number,
    totalPages: PropTypes.number
  };

  onChange = (pageNum: number) => {
    gtmEventPush({
      method: 'adListings',
      args: {
        itemLabel: 'Pagination'
      }
    });
    if (isWindow() && isWindowProp('location')) {
      updateQueryString([{ key: 'page', val: pageNum }]);
      this.props.fetchUpdatedQuery();
      scrollToTopOfPage();
    }
  };

  /**
   * Renders <Pagination /> component.
   *
   * @return {JSX} - renders a Pagination.
   */
  render() {
    let { currentPage, totalPages } = this.props;
    totalPages = totalPages <= 500 ? totalPages : 500;
    const remainingPages = totalPages - currentPage;

    const showDoubleEllipsis = currentPage >= 2;
    const showSecondEllipsis = remainingPages >= 1 && currentPage < totalPages;
    const isEnoughRemainingPages = remainingPages >= 1;
    const totalPagesDigits = totalPages.toString().length;

    return (
      <div className={styles.classPagination}>
        {currentPage !== 1 && (
          <button
            onClick={() => this.onChange(currentPage - 1)}
            className={classNames(
              styles.classPaginationButton,
              styles.classPaginationNavigation,
              styles.classPaginationNavigationPrevious
            )}
          >
            <Icon iconName={'angle-right'} size={'medium'} />
          </button>
        )}

        {showDoubleEllipsis && (
          <button
            onClick={() => this.onChange(1)}
            className={classNames(
              styles.classPaginationButton,
              currentPage === 1 ? styles.classPaginationActive : null
            )}
          >
            1
          </button>
        )}

        {showDoubleEllipsis && (
          <span
            className={classNames(
              styles.classPaginationButton,
              styles.classPaginationSpacer
            )}
          >
            ...
          </span>
        )}

        {showDoubleEllipsis && (
          <button
            key={currentPage}
            onClick={() => this.onChange(currentPage)}
            className={classNames(
              styles.classPaginationButton,
              styles.classPaginationActive,
              currentPage.toString().length >= 3
                ? styles.classPaginationSmaller
                : null
            )}
          >
            {currentPage}
          </button>
        )}

        {!showDoubleEllipsis &&
          [...Array(currentPage)].map((_, i) => (
            <button
              key={i + 1}
              onClick={() => this.onChange(i + 1)}
              className={classNames(
                styles.classPaginationButton,
                currentPage === i + 1 ? styles.classPaginationActive : null,
                (i + 1).toString().length >= 3
                  ? styles.classPaginationSmaller
                  : null
              )}
            >
              {i + 1}
            </button>
          ))}

        {showSecondEllipsis && (
          <span
            className={classNames(
              styles.classPaginationButton,
              styles.classPaginationSpacer
            )}
          >
            ...
          </span>
        )}

        {isEnoughRemainingPages && (
          <button
            onClick={() => this.onChange(totalPages)}
            className={classNames(
              styles.classPaginationButton,
              currentPage === totalPages ? styles.classPaginationActive : null,
              totalPagesDigits >= 3 ? styles.classPaginationSmaller : null
            )}
          >
            {totalPages}
          </button>
        )}

        {currentPage !== totalPages && (
          <button
            onClick={() => this.onChange(currentPage + 1)}
            className={classNames(
              styles.classPaginationButton,
              styles.classPaginationNavigation,
              styles.classPaginationNavigationNext
            )}
          >
            <Icon iconName={'angle-left'} size={'medium'} />
          </button>
        )}
      </div>
    );
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/Results/Pagination/index.js